<script setup lang="ts">
import { useAccountStore } from '@caks/shared/store/store.account'
import { ButtonMain } from '@caks/uikit/button'

const store = useAccountStore()
const isDelivery = localStorage.getItem('order') === 'delivery'

onMounted(() => {
  localStorage.removeItem('order')
  localStorage.removeItem('address')
  localStorage.removeItem('addressId')
  localStorage.removeItem('cart')
  localStorage.removeItem('promo')
  store.clearCart()
  store.clearLocation()
})
</script>

<template>
  <div class="accepted">
    <img src="/order-accepted.jpg" alt="order-accepted" class="accepted__image" />
    <h1 class="accepted__title">Ваш заказ принят</h1>
    <p v-if="isDelivery" class="accepted__subtitle">
      Ожидайте 35-60 минут, вам придет Push-уведомление, когда передадим заказ курьеру
    </p>
    <button-main class="accepted__button" @click="$router.push('/')">На главную</button-main>
  </div>
</template>

<style scoped lang="scss">
.accepted {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  width: 100%;
  margin-top: 32px;

  &__image {
    width: 343px;
  }

  &__title {
    @include h1-1;
  }

  &__subtitle {
    @include h5-2;
    color: $sub-text;
  }

  &__button {
    width: 289px;
  }
}
</style>
